
// before 20-5-2026
// import React, { useEffect, useState } from 'react';
// import { RegionsActions } from './RegionsActions';
// import Table from 'react-bootstrap/esm/Table';
// import { useDispatch, useSelector } from 'react-redux';
// import { GetAllRegionsData } from '../../Redux/Actions/Regions_Action';
// import { Col, Container, Row, Spinner } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import AddIcon from '@mui/icons-material/Add';
// import { Snackbar, Alert, useMediaQuery } from '@mui/material';
// import { CopyToClipboard } from 'react-copy-to-clipboard';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import moment from 'moment';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { useTheme } from '@mui/material/styles';

// export const RegionTable = () => {
//   const [loading, setloading] = useState(true);
//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const theme = useTheme();
//   const mode = theme.palette.mode; // جلب الوضع الحالي (dark / li

//   const dispatch = useDispatch();

//   const run = async () => {
//     setloading(true);
//     await dispatch(GetAllRegionsData());
//     setloading(false);
//   };

//   useEffect(() => {
//     run();
//   }, [dispatch]);

//   const res_All_Regions = useSelector((state) => state.AllRegions.Region);

//   let res_get_AllRegions_array = Array.isArray(res_All_Regions?.data) ? res_All_Regions.data : [];

//   //clipboard copy channal id
//   const [open, setOpen] = useState(false);
//   const handleCopy = () => {
//     setOpen(true); // عرض رسالة تأكيد عند النسخ
//     setTimeout(() => setOpen(false), 2000); // إخفاء الرسالة بعد 2 ثانية
//   };

//   const homeRoute =
//     userlogin?.data?.role === 'Admin'
//       ? '/AllLeadsForAdmin'
//       : userlogin?.data?.role === 'Marketer'
//         ? '/ALLLeadsForMarketer'
//         : '/'; // fallback

//   const [columns, setColumns] = useState([
//     { key: 'copyId', label: 'Copy Id', visible: true, width: 120 },
//     { key: 'RegionName', label: 'Region Name', visible: true, width: 160 },
//     { key: 'createdAt', label: 'Creation Date', visible: true, width: 180 },
//     { key: 'actions', label: 'Actions', visible: true, width: 120 },
//   ]);

//   const startResizing = (e, colIndex) => {
//     e.preventDefault();
//     const startX = e.clientX;
//     const startWidth = columns[colIndex].width;

//     const onMouseMove = (e) => {
//       const newWidth = Math.max(startWidth + e.clientX - startX, 50);
//       setColumns((prevCols) => {
//         const newCols = [...prevCols];
//         newCols[colIndex] = { ...newCols[colIndex], width: newWidth };
//         return newCols;
//       });
//     };

//     const onMouseUp = () => {
//       document.removeEventListener('mousemove', onMouseMove);
//       document.removeEventListener('mouseup', onMouseUp);
//     };

//     document.addEventListener('mousemove', onMouseMove);
//     document.addEventListener('mouseup', onMouseUp);
//   };

//   const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

//   return (
//     <Container className="startpage">
//       <Row>
//         <Col sm={2}></Col>

//         <Col sm={10}>
//           {/* <div className='mx-4 d-flex'>
//                     <div className='mx-3'>Regions</div>
//                     <a style={{textDecoration:'none'}} href='/' className='goback'>{"<<"} Go Home </a>
        
//                 </div> */}

//           <div className="d-flex justify-content-between">
//             <div>
//               <div>
//                 <Link to={homeRoute} style={{ textDecoration: 'none', color: '#102dff' }}>
//                   <span style={{ fontWeight: 'bold' }}>Home</span>
//                 </Link>

//                 <KeyboardDoubleArrowRightIcon />

//                 <span style={{ color: '#666' }}>Regions</span>
//               </div>{' '}
//             </div>
//           </div>

//           <div className="d-flex justify-content-end w-100">
//             <Link to={`/AddRegions`} style={{ textDecoration: 'none' }}>
//               <div
//                 className="public-color btn btn-success icon-plus addnewclientbtn w-100 my-2"
//                 style={{ background: '#102dff' }}
//               >
//                 <AddIcon /> Add New Region
//               </div>
//             </Link>
//           </div>
//           {/* Column toggles */}
//           <div className="mb-2">
//             {columns.map((col, index) => (
//               <label key={col.key} style={{ marginRight: '10px' }}>
//                 <input
//                   type="checkbox"
//                   checked={col.visible}
//                   onChange={() => {
//                     const newCols = [...columns];
//                     newCols[index].visible = !newCols[index].visible;
//                     setColumns(newCols);
//                   }}
//                 />{' '}
//                 {col.label}
//               </label>
//             ))}
//           </div>

//           {/* Table Section */}
//           {loading ? (
//             <div
//               className="d-flex justify-content-center align-items-center"
//               style={{ minHeight: '200px' }}
//             >
//               <Spinner animation="border" variant="primary">
//                 <span className="visually-hidden">Loading...</span>
//               </Spinner>
//             </div>
//           ) : res_get_AllRegions_array.length > 0 ? (
//             <div
//               style={{
//                 overflowX: 'auto',
//                 width: '100%',
//                 marginTop: '20px',
//                 borderRadius: '15px',
//                 //  boxShadow: mode === "dark"
//                 //    ? '0 4px 20px rgba(144, 202, 249, 0.15)'
//                 //    : '0 4px 20px rgba(15, 118, 135, 0.15)'
//               }}
//             >
//               <Table
//                 size="sm"
//                 responsive
//                 style={{
//                   minWidth: isExtraSmallScreen ? '800px' : '100%',
//                   textAlign: 'center',
//                   color: mode === 'dark' ? '#90caf9' : '#102dff',
//                   backgroundColor: mode === 'dark' ? '#252525' : '#fff',
//                   // borderCollapse: 'separate',
//                   borderSpacing: '0',
//                   borderRadius: '15px',
//                   overflow: 'hidden',
//                 }}
//                 // className={` ${mode === 'dark' ? 'table-dark' : 'table-light'}`}
//               >
//                 <thead>
//                   <tr>
//                     {columns
//                       .filter((col) => col.visible)
//                       .map((col, index) => (
//                         <th
//                           key={col.key}
//                           style={{
//                             position: 'relative',
//                             color: '#666',
//                             minWidth: `${col.width}px`,
//                             maxWidth: `${col.width}px`,
//                             whiteSpace: 'nowrap',
//                             borderBottom: mode === 'dark' ? '1px solid #90caf9' : '1px solid #666',
//                           }}
//                         >
//                           {col.label}
//                           <div
//                             onMouseDown={(e) => startResizing(e, index)}
//                             style={{
//                               position: 'absolute',
//                               right: 0,
//                               top: 0,
//                               height: '100%',
//                               width: '5px',
//                               cursor: 'col-resize',
//                               userSelect: 'none',
//                             }}
//                           />
//                         </th>
//                       ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {res_get_AllRegions_array.map((item) => (
//                     <tr key={item._id}>
//                       {columns
//                         .filter((col) => col.visible)
//                         .map((col) => {
//                           switch (col.key) {
//                             case 'copyId':
//                               return (
//                                 <td key={col.key} style={{ color: '#102dff' }}>
//                                   <CopyToClipboard onCopy={handleCopy}>
//                                     <div onClick={() => navigator.clipboard.writeText(item._id)}>
//                                       <ContentCopyIcon />
//                                     </div>
//                                   </CopyToClipboard>
//                                   <Snackbar open={open} autoHideDuration={2000}>
//                                     <Alert severity="success">Copy Done</Alert>
//                                   </Snackbar>
//                                 </td>
//                               );
//                             case 'RegionName':
//                               return (
//                                 <td key={col.key} style={{ color: '#666' }}>
//                                   {item.name}
//                                 </td>
//                               );
//                             case 'createdAt':
//                               return (
//                                 <td key={col.key} style={{ color: '#666' }}>
//                                   {item.createdAt
//                                     ? moment(item.createdAt).format('DD/MM/YYYY h:mm A')
//                                     : '-'}
//                                 </td>
//                               );
//                             case 'actions':
//                               return (
//                                 <td key={col.key}>
//                                   <RegionsActions regions={item} allregions={run} />
//                                 </td>
//                               );
//                             default:
//                               return <td key={col.key}>-</td>;
//                           }
//                         })}
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//           ) : (
//             <div
//               className="text-center mt-4"
//               style={{ color: mode === 'dark' ? '#ffffff' : '#000000' }}
//             >
//               No regions available.
//             </div>
//           )}
//         </Col>
//       </Row>
//     </Container>
//   );
// };


























// 20-5-2026
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Snackbar, Alert } from '@mui/material';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from 'moment';
import { GetAllRegionsData } from '../../Redux/Actions/Regions_Action';
import { RegionsActions } from './RegionsActions';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';
// import './AllProjects.css';

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconSearch  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
const IconFilter  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>;
const IconCopy    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
const IconPlus    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IconRegion  = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/><circle cx="12" cy="9" r="2.5"/></svg>;
const IconGlobe   = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>;
const IconTrend   = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>;

/* ─── Constants ──────────────────────────────────────────────────────────── */
const EXPANDED_WIDTH = 242;

/* ─── Component ──────────────────────────────────────────────────────────── */
export const RegionTable = () => {
  const dispatch = useDispatch();
  const theme    = useTheme();
  const mode     = theme.palette.mode;

  const [loading,      setLoading]      = useState(true);
  const [searchTerm,   setSearchTerm]   = useState('');
  const [dateFilter,   setDateFilter]   = useState('all');
  const [showFilter,   setShowFilter]   = useState(false);
  const [page,         setPage]         = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [copyOpen,     setCopyOpen]     = useState(false);
  const [userlogin,    setUserlogin]    = useState(null);
  // const [sidebarWidth, setSidebarWidth] = useState(EXPANDED_WIDTH);
  const sidebarWidth = useSidebarWidth();

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  // useEffect(() => {
  //   const h = (e) => setSidebarWidth(e.detail?.width ?? EXPANDED_WIDTH);
  //   window.addEventListener('sidebarResized', h);
  //   return () => window.removeEventListener('sidebarResized', h);
  // }, []);

  const run = async () => {
    setLoading(true);
    await dispatch(GetAllRegionsData());
    setLoading(false);
  };
  useEffect(() => { run(); }, [dispatch]);

  const res_All_Regions          = useSelector((state) => state.AllRegions.Region);
  const res_get_AllRegions_array = Array.isArray(res_All_Regions?.data) ? res_All_Regions.data : [];

  const filtered = res_get_AllRegions_array.filter((r) => {
    const matchSearch = !searchTerm || r.name?.toLowerCase().includes(searchTerm.toLowerCase());
    let matchDate = true;
    if (dateFilter !== 'all') {
      const created = moment(r.createdAt);
      const now     = moment();
      if (dateFilter === 'today') matchDate = created.isSame(now, 'day');
      if (dateFilter === 'week')  matchDate = created.isAfter(now.clone().subtract(7, 'days'));
      if (dateFilter === 'month') matchDate = created.isAfter(now.clone().subtract(30, 'days'));
    }
    return matchSearch && matchDate;
  });

  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const pageItems  = filtered.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  const thisMonth = res_get_AllRegions_array.filter(r =>
    moment(r.createdAt).isAfter(moment().subtract(30, 'days'))
  ).length;
  const newestRegion = res_get_AllRegions_array.length
    ? res_get_AllRegions_array.reduce((a, b) => new Date(a.createdAt) > new Date(b.createdAt) ? a : b)
    : null;

  const homeRoute = userlogin?.data?.role === 'Admin'    ? '/AllLeadsForAdmin'
                  : userlogin?.data?.role === 'Marketer' ? '/ALLLeadsForMarketer'
                  : '/Dashboard';

  const buildPageNumbers = () => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const pages = [];
    if (page <= 4)              pages.push(1, 2, 3, 4, 5, '...', totalPages);
    else if (page >= totalPages - 3) pages.push(1, '...', totalPages-4, totalPages-3, totalPages-2, totalPages-1, totalPages);
    else                        pages.push(1, '...', page-1, page, page+1, '...', totalPages);
    return pages;
  };

  /* ── render ── */
  return (
    <>
      {/*
        ✅ الـ shell يبدأ من بعد الـ sidebar مباشرةً ويملأ باقي الشاشة
        position: fixed + left + right: 0 = يملأ كل المساحة المتبقية بالظبط
      */}
      <div
        className={`ap-shell ${mode}`}
        style={{
          position: 'fixed',
          top: '50px',        /* ارتفاع الـ topbar */
          left: sidebarWidth, /* يبدأ من بعد الـ sidebar */
          right: 0,
          bottom: 0,
          transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
          overflowY: 'auto',
          overflowX: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >

        {/* ─── Breadcrumbs ─── */}
        <section style={{ padding: '16px 20px 0', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}>
            <Link
              to={homeRoute}
              style={{ textDecoration: 'none', color: mode === 'dark' ? '#9ca3af' : '#6b7280', fontWeight: 500, fontFamily: "'DM Sans', sans-serif" }}
            >
              Home
            </Link>
            <span style={{ color: mode === 'dark' ? '#4b5563' : '#d1d5db' }}>/</span>
            <span style={{ color: mode === 'dark' ? '#e5e7eb' : '#111827', fontWeight: 600, fontFamily: "'DM Sans', sans-serif" }}>
              Regions
            </span>
          </div>
        </section>

        {/* ─── Stats ─── */}
        <section className="ap-stats" style={{ flexShrink: 0 }}>
          <div className="ap-stat-card light">
            <div>
              <div className="ap-stat-label">TOTAL REGIONS</div>
              <div className="ap-stat-value">{res_get_AllRegions_array.length}</div>
              <div className="ap-stat-badge green">↑ Active in system</div>
            </div>
            <div className="ap-stat-icon light-icon"><IconRegion /></div>
          </div>

          <div className="ap-stat-card light">
            <div>
              <div className="ap-stat-label">ADDED THIS MONTH</div>
              <div className="ap-stat-value large">{thisMonth}</div>
              <div className="ap-stat-badge green">Last 30 days</div>
            </div>
            <div className="ap-stat-icon light-icon"><IconGlobe /></div>
          </div>

          <div className="ap-stat-card dark-card">
            <div>
              <div className="ap-stat-label white">LATEST REGION</div>
              <div className="ap-stat-value white" style={{ fontSize: 18, marginTop: 4 }}>
                {newestRegion?.name || '—'}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px' }}>
                <span className="ap-badge-pill">MOST RECENT</span>
                <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '11px' }}>
                  {newestRegion ? moment(newestRegion.createdAt).format('MMM DD, YYYY') : ''}
                </span>
              </div>
            </div>
            <div className="ap-stat-icon dark-icon"><IconTrend /></div>
          </div>
        </section>

        {/* ─── Table Section ─── */}
        <section
          className="ap-table-section"
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            minHeight: 0,
          }}
        >
          {/* header */}
          <div className="ap-table-header" style={{ flexShrink: 0 }}>
            <div>
              <div className="ap-table-title-label">GEOGRAPHIC</div>
              <div className="ap-table-title">REGIONS</div>
            </div>
            <div className="ap-table-actions">
              <div className="ap-search-inline">
                <IconSearch />
                <input
                  placeholder="Search regions by name…"
                  value={searchTerm}
                  onChange={(e) => { setSearchTerm(e.target.value); setPage(1); }}
                />
              </div>
              <button className="ap-filter-btn" onClick={() => setShowFilter(!showFilter)}>
                <IconFilter /> Filter
              </button>
              <Link to="/AddRegions" style={{ textDecoration: 'none' }}>
                <button className="ap-create-btn"><IconPlus /> Add New Region</button>
              </Link>
            </div>
          </div>

          {/* filter row */}
          {showFilter && (
            <div className="ap-filter-row" style={{ flexShrink: 0 }}>
              <select value={dateFilter} onChange={(e) => { setDateFilter(e.target.value); setPage(1); }}>
                <option value="all">All Dates</option>
                <option value="today">Today</option>
                <option value="week">Last 7 Days</option>
                <option value="month">Last 30 Days</option>
              </select>
              <button className="ap-clear-btn" onClick={() => { setSearchTerm(''); setDateFilter('all'); setPage(1); }}>
                Clear
              </button>
            </div>
          )}

          {/* Table wrap */}
          <div className="ap-table-wrap" style={{ flex: 1, overflowY: 'auto', overflowX: 'auto' }}>
            <table className="ap-table">
              <thead>
                <tr>
                  <th style={{ width: 40, position: 'sticky', top: 0, zIndex: 2, background: mode === 'dark' ? '#1a1a2e' : '#fff' }}>
                    <input type="checkbox" className="ap-checkbox" />
                  </th>
                  <th style={{ position: 'sticky', top: 0, zIndex: 2, background: mode === 'dark' ? '#1a1a2e' : '#fff' }}>REGION NAME</th>
                  <th style={{ position: 'sticky', top: 0, zIndex: 2, background: mode === 'dark' ? '#1a1a2e' : '#fff' }}>CREATED DATE</th>
                  <th style={{ position: 'sticky', top: 0, zIndex: 2, background: mode === 'dark' ? '#1a1a2e' : '#fff' }}>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={4} className="ap-empty"><div className="ap-spinner" /><span>Loading regions…</span></td></tr>
                ) : pageItems.length === 0 ? (
                  <tr><td colSpan={4} className="ap-empty"><IconSearch /><p>No regions found</p></td></tr>
                ) : (
                  pageItems.map((item) => (
                    <tr key={item._id} className="ap-row">
                      <td><input type="checkbox" className="ap-checkbox" /></td>
                      <td>
                        <div className="ap-project-cell">
                          <div className="ap-project-thumb">{item.name?.slice(0, 2).toUpperCase() || 'RG'}</div>
                          <span className="ap-project-name">{item.name || '—'}</span>
                        </div>
                      </td>
                      <td className="ap-cell-muted" style={{ fontSize: 13 }}>
                        {item.createdAt ? moment(item.createdAt).format('MMM DD, YYYY') : '—'}
                      </td>
                      <td>
                        <div className="ap-actions">
                          <CopyToClipboard text={item._id} onCopy={() => { setCopyOpen(true); setTimeout(() => setCopyOpen(false), 2000); }}>
                            <button className="ap-action-btn" title="Copy ID"><IconCopy /></button>
                          </CopyToClipboard>
                          <RegionsActions regions={item} allregions={run} />
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* ✅ Pagination sticky في أسفل الجدول */}
          {filtered.length > 0 && (
            <div
              className="ap-pagination"
              style={{
                position: 'sticky',
                bottom: 0,
                zIndex: 5,
                flexShrink: 0,
                backgroundColor: mode === 'dark' ? '#1a1a2e' : '#ffffff',
                borderTop: `1px solid ${mode === 'dark' ? '#2a2a45' : '#e8eaf0'}`,
                boxShadow: '0 -2px 12px rgba(0,0,0,0.06)',
              }}
            >
              <div className="ap-pagination-info">
                <span>Items per page:</span>
                <select
                  className="ap-page-select"
                  value={itemsPerPage}
                  onChange={(e) => { setItemsPerPage(Number(e.target.value)); setPage(1); }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                <span>
                  Showing <strong>{(page-1)*itemsPerPage+1}–{Math.min(page*itemsPerPage, filtered.length)}</strong> of <strong>{filtered.length}</strong> regions
                </span>
              </div>
              <div className="ap-pagination-btns">
                <button className="ap-pag-btn" onClick={() => setPage(1)} disabled={page===1}>⟨|</button>
                <button className="ap-pag-btn" onClick={() => setPage(p=>Math.max(1,p-1))} disabled={page===1}>‹</button>
                {buildPageNumbers().map((n, idx) =>
                  n === '...'
                    ? <span key={`e-${idx}`} className="ap-pag-ellipsis">…</span>
                    : <button key={n} className={`ap-pag-btn ${page===n?'active':''}`} onClick={() => setPage(n)}>{n}</button>
                )}
                <button className="ap-pag-btn" onClick={() => setPage(p=>Math.min(totalPages,p+1))} disabled={page===totalPages}>›</button>
                <button className="ap-pag-btn" onClick={() => setPage(totalPages)} disabled={page===totalPages}>|⟩</button>
              </div>
            </div>
          )}
        </section>

        {/* Footer */}
        <footer className="ap-footer" style={{ flexShrink: 0 }}>
          <span>© 2026 Realatix CRM. Smart CRM that connects customers, data, and sales in one safe place.</span>
        </footer>

      </div>

      <Snackbar open={copyOpen} autoHideDuration={2000}>
        <Alert severity="success" sx={{ width: '100%' }}>Copied to clipboard!</Alert>
      </Snackbar>
    </>
  );
};